/* eslint-disable */
import React from "react"
import styled from "styled-components"
import Slide from "react-reveal"
import ViewMoreInstagram from "../components/ViewMoreInstagram"

const Wrapper = styled.div`
  width: 100%;
  margin: 15px auto;
`

const InstagramGrid = styled.div`
  columns: 5;

  div {
    margin: 0 15px 30px;
  }

  div img {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: 767px) {
    columns: 4;
    column-gap: 4px;

    div {
      margin: 0 5px 10px;
    }
  }
`

export default ({ posts }) => {
  return (
    <Wrapper>
      <InstagramGrid>
        {posts.edges.map(post => (
          <div key={post.node.id}>
            <Slide bottom>
              <img src={post.node.original} />
            </Slide>
          </div>
        ))}
      </InstagramGrid>
      <Slide bottom>
        <ViewMoreInstagram />
      </Slide>
    </Wrapper>
  )
}
